import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { PieChart, Pie, Cell } from 'recharts';

// Define the Maersk font family
const maerskFontFamily = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';

const LandingPageInsights = ({ title, data, total, cardLoading = false, onNumberClick = null, colors }) => {
  return (
    <Box sx={{ width: "100%", fontFamily: maerskFontFamily }}>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#f7f7f7",
          flexDirection: "column",
          borderRadius: 2,
          p: 2,
          height: "220px",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
          fontFamily: maerskFontFamily
        }}
      >
        {cardLoading ? (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10
            }}
          >
            <CircularProgress sx={{ color: "#333" }} />
          </Box>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                width: "90%",
                alignItems: "flex-start"
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", fontFamily: maerskFontFamily }}>
                {title}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                height: "150px",
                overflow: "auto",
                width: "90%",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  maxHeight: "100%"
                }}
              >
                {data.map((entry, index) => (
                  <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: colors[index % colors.length]
                      }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        cursor: isNaN(entry.value) || entry.value === 0 ? "default" : "pointer",
                        "&:hover": {
                          color: isNaN(entry.value) || entry.value === 0 ? "inherit" : "#0073ab"
                        }
                      }}
                      onClick={() => {
                        if (onNumberClick && !isNaN(entry.value) && entry.value > 0) {
                          const clickType = entry.label.toLowerCase();
                          onNumberClick(clickType);
                        }
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#555",
                          cursor: isNaN(entry.value) || entry.value === 0 ? "default" : "pointer",
                          fontFamily: maerskFontFamily,
                          "&:hover": {
                            color: isNaN(entry.value) || entry.value === 0 ? "inherit" : "#0073ab"
                          }
                        }}
                      >
                        {entry.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          cursor: isNaN(entry.value) || entry.value === 0 ? "default" : "pointer",
                          fontFamily: maerskFontFamily,
                          "&:hover": {
                            color: isNaN(entry.value) || entry.value === 0 ? "inherit" : "#0073ab"
                          }
                        }}
                      >
                        {isNaN(entry.value) ? 0 : entry.value}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>

              <Box sx={{ position: "relative", width: 120, height: 120 }}>
                <PieChart 
                  width={120} 
                  height={120}
                  style={{
                    userSelect: "none",
                    WebkitUserSelect: "none",
                    MozUserSelect: "none",
                    msUserSelect: "none",
                    pointerEvents: "none"
                  }}
                >
                  <Pie
                    data={data.map((item) => ({
                      ...item,
                      value: isNaN(item.value) ? 0 : item.value
                    }))}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={60}
                    dataKey="value"
                    startAngle={90}
                    endAngle={450}
                    isAnimationActive={false}
                  >
                    {data.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                    ))}
                  </Pie>
                </PieChart>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "#333",
                    fontFamily: maerskFontFamily,
                  }}
                >
                  {isNaN(total) ? 0 : total}
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: "center" }}>
              <Typography
                sx={{ fontWeight: "normal", color: "#666", fontFamily: maerskFontFamily }}
              >
                {title === "Overdue Changes" 
                  ? `Past 30 days` 
                  : title === "Conflicting Changes"
                  ? `Upcoming 30 days`
                  : title === "Incidents due to Changes"
                  ? `Past 30 days`
                  : `Past & Upcoming 30 days`}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default LandingPageInsights;
